document.addEventListener('DOMContentLoaded', function(event) {

 $(document).ready(function () {
      
    var actualBlog = $('.actualBlog').attr('data-blog');
    
    $('.collapse-tags-tab').each(function() {
      if($(this).attr('data-category') == actualBlog) {
        $(this).addClass('active');
        $(this).addClass('animRight');
        $(this).show();
      } else {
        $(this).removeClass('active');
        $(this).hide();
      }
    });


    $('.collapse-content').removeClass('loading');
     
    $('.trigger-tags-collapse').on('click', function(event) {
      event.preventDefault();
      var actualTab = $(this).attr('data-tab');
      var actualTabEl = '.collapse-tags-tab.' + $(this).attr('data-tab');
      
      if ($(this).hasClass('active')) {
         console.log('Inside if - has class active');
      } else {
        console.log('Inside else - has not class active');
        $('.trigger-tags-collapse').removeClass('active');
        $(this).addClass('active');
  
        $('.collapse-tags-tab').each(function() {
          
          if($(this).attr('data-category') == actualTab) {
            $(this).addClass('active');
            $(this).addClass('animRight');
            $(this).show();
            //console.log('Tabs name ACTUAL[IF]: ', actualTab);
            //console.log('Tabs name attr[IF]: ', $(this).attr('data-category'));
          } else {
            $(this).removeClass('active');
            $(this).removeClass('animRight');
            $(this).hide();
            //console.log('Tabs name ACTUAL[ELSE]: ', actualTab);
            //console.log('Tabs name attr[ELSE]: ', $(this).attr('data-category'));
          }
        });
        
         $(actualTabEl).show();
      }
      
    });

  });
});